(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eo-flipper-home"] && !Shopify.designMode) return;
  try {
    
function initFlipper(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const featured=root.querySelector('.ef-featured');
  const swap=(url,alt)=>{if(!featured||!url)return;featured.removeAttribute('srcset');featured.src=url;if(alt)featured.alt=alt;};
  root.querySelectorAll('[data-ef-image]').forEach(button=>button.addEventListener('click',()=>{swap(button.dataset.efImage,button.dataset.efAlt);root.querySelectorAll('[data-ef-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));
  const quantity=root.querySelector('[name="quantity"]');
  root.querySelectorAll('[data-ef-step]').forEach(button=>button.addEventListener('click',()=>{if(!quantity)return;try{Number(button.dataset.efStep)>0?quantity.stepUp():quantity.stepDown();}catch{quantity.value=quantity.min||1;}quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
  const selector=root.querySelector('select[name="id"]');
  if(selector)selector.addEventListener('change',()=>{const option=selector.selectedOptions[0];root.querySelector('[data-ef-price]').textContent=option.dataset.price;const compare=root.querySelector('[data-ef-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;root.querySelectorAll('[data-ef-submit]').forEach(button=>{button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.add;});quantity.min=option.dataset.min||1;quantity.step=option.dataset.step||1;if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;swap(option.dataset.image);});
}
document.querySelectorAll('.ef').forEach(initFlipper);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ef').forEach(initFlipper));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-flipper-product"] && !Shopify.designMode) return;
  try {
    
function initFlipper(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  root.addEventListener('keydown',event=>{if(event.key==='Escape'){const opened=Array.from(root.querySelectorAll('.ef-dropdown[open],.ef-mobile-menu[open]')).pop();if(opened){opened.open=false;opened.querySelector('summary').focus();event.preventDefault();}}});
  const featured=root.querySelector('.ef-featured');
  const swap=(url,alt)=>{if(!featured||!url)return;featured.removeAttribute('srcset');featured.src=url;if(alt)featured.alt=alt;};
  root.querySelectorAll('[data-ef-image]').forEach(button=>button.addEventListener('click',()=>{swap(button.dataset.efImage,button.dataset.efAlt);root.querySelectorAll('[data-ef-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));
  const quantity=root.querySelector('[name="quantity"]');
  root.querySelectorAll('[data-ef-step]').forEach(button=>button.addEventListener('click',()=>{if(!quantity)return;try{Number(button.dataset.efStep)>0?quantity.stepUp():quantity.stepDown();}catch{quantity.value=quantity.min||1;}quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
  const selector=root.querySelector('select[name="id"]');
  if(selector)selector.addEventListener('change',()=>{const option=selector.selectedOptions[0];root.querySelector('[data-ef-price]').textContent=option.dataset.price;const compare=root.querySelector('[data-ef-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;root.querySelectorAll('[data-ef-submit]').forEach(button=>{button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.add;});quantity.min=option.dataset.min||1;quantity.step=option.dataset.step||1;if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;swap(option.dataset.image);});
}
document.querySelectorAll('.ef').forEach(initFlipper);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ef').forEach(initFlipper));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-product-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('.ep-review-form-toggle').forEach(details=>{if(details.querySelector('.ep-form-success,[role="alert"]')){details.open=true;const message=details.querySelector('.ep-form-success,[role="alert"]');message.scrollIntoView({block:'center'});message.focus?.();}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-shared-header"]) return;
  try {
    
function initSiteHeader(root){if(root.dataset.navReady)return;root.dataset.navReady='true';root.addEventListener('keydown',event=>{if(event.key==='Escape'){const opened=Array.from(root.querySelectorAll('.ef-dropdown[open],.ef-mobile-menu[open]')).pop();if(opened){opened.open=false;opened.querySelector('summary').focus();event.preventDefault();}}});document.addEventListener('click',event=>{if(!root.contains(event.target))root.querySelectorAll('.ef-dropdown[open],.ef-mobile-menu[open]').forEach(menu=>menu.open=false);});}
document.querySelectorAll('.ef-site-header').forEach(initSiteHeader);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ef-site-header').forEach(initSiteHeader));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-tech-home"] && !Shopify.designMode) return;
  try {
    
function initFlipper(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  root.addEventListener('keydown',event=>{if(event.key==='Escape'){const opened=Array.from(root.querySelectorAll('.ef-dropdown[open],.ef-mobile-menu[open]')).pop();if(opened){opened.open=false;opened.querySelector('summary').focus();event.preventDefault();}}});
  const featured=root.querySelector('.ef-featured');
  const swap=(url,alt)=>{if(!featured||!url)return;featured.removeAttribute('srcset');featured.src=url;if(alt)featured.alt=alt;};
  root.querySelectorAll('[data-ef-image]').forEach(button=>button.addEventListener('click',()=>{swap(button.dataset.efImage,button.dataset.efAlt);root.querySelectorAll('[data-ef-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));
  const quantity=root.querySelector('[name="quantity"]');
  root.querySelectorAll('[data-ef-step]').forEach(button=>button.addEventListener('click',()=>{if(!quantity)return;try{Number(button.dataset.efStep)>0?quantity.stepUp():quantity.stepDown();}catch{quantity.value=quantity.min||1;}quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
  const selector=root.querySelector('select[name="id"]');
  if(selector)selector.addEventListener('change',()=>{const option=selector.selectedOptions[0];root.querySelector('[data-ef-price]').textContent=option.dataset.price;const compare=root.querySelector('[data-ef-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;root.querySelectorAll('[data-ef-submit]').forEach(button=>{button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.add;});quantity.min=option.dataset.min||1;quantity.step=option.dataset.step||1;if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;swap(option.dataset.image);});
}
document.querySelectorAll('.ef').forEach(initFlipper);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ef').forEach(initFlipper));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
